import { HStack, Select, Spacer, Text } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  selectedCountry?: string;
  onChangeCountry: (country: string) => void;
  countryOptions: string[];
}

export const CountryAdminCountrySelection: FC<Props> = ({
  countryOptions,
  onChangeCountry,
  selectedCountry,
}) => {
  const { t } = useTranslation();

  if (countryOptions.length < 2) return null;

  return (
    <HStack justifyItems='flex-end' w='full'>
      <Spacer />
      <Text fontWeight='bold' whiteSpace='nowrap'>
        {t('admin.general.managedCountry')}
      </Text>
      <Select
        w='auto'
        bg='form.inputBackground'
        borderColor='form.inputBorder'
        borderRadius='4'
        shadow='none !important'
        _focusVisible={{
          borderColor: 'form.inputBorder',
        }}
        onChange={(e) => onChangeCountry(e.target.value)}
        size='sm'
        value={selectedCountry}
      >
        {countryOptions.map((country) => (
          <option key={country} value={country}>
            {t(`countries.${country}`)}
          </option>
        ))}
      </Select>
    </HStack>
  );
};
